import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';

export const useNumberBooleanChoices = () => {
  const translate = useTypedTranslate();

  return [
    { id: '1', label: translate('app.common.yes') },
    { id: '0', label: translate('app.common.no') },
  ];
};
